import React from "react";
import { FiRotateCw } from "react-icons/fi";
import api from "@/services/api";
import toast from "react-hot-toast";

export default function ScreeningCell({ candidate, onSelectCandidate, onRefresh }) {
  const handleRetry = async (e) => {
    e.stopPropagation();
    try {
      await api.put(`/application/${candidate._id}`, { screening_status: "pending" });
      toast.success("Queued");
      onRefresh();
    } catch (err) {
      toast.error("Failed to queue screening");
    }
  };

  const retryBtn = (
    <button
      onClick={handleRetry}
      className="p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors"
      title="Retry"
    >
      <FiRotateCw className="w-3 h-3" />
    </button>
  );

  if (!candidate.screening_status && candidate.screening_score == null) {
    return <span className="text-sm text-gray-300">-</span>;
  }

  if (candidate.screening_status === "pending") {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-50 text-amber-600">
        <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />
        Pending
      </span>
    );
  }

  if (candidate.screening_status === "in_progress") {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-600">
        <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 animate-pulse" />
        Running…
      </span>
    );
  }

  if (candidate.screening_status === "error") {
    return (
      <div className="flex items-center justify-center gap-1">
        <span
          className="px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-600"
          title={candidate.screening_error}
        >
          Error
        </span>
        {retryBtn}
      </div>
    );
  }

  if (candidate.screening_eliminated) {
    return (
      <span
        className="px-2 py-1 rounded-full text-xs font-bold cursor-pointer bg-red-100 text-red-700"
        title={candidate.screening_explanation}
        onClick={() => onSelectCandidate(candidate)}
      >
        Eliminated
      </span>
    );
  }

  if (candidate.screening_score != null) {
    const score = candidate.screening_score;
    return (
      <div className="relative group/tooltip inline-block">
        <span
          className={`px-2 py-1 rounded-full text-xs font-bold cursor-pointer ${
            score >= 80
              ? "bg-emerald-100 text-emerald-700"
              : score >= 60
              ? "bg-blue-100 text-blue-700"
              : score >= 40
              ? "bg-yellow-100 text-yellow-700"
              : "bg-gray-100 text-gray-700"
          }`}
          onClick={() => onSelectCandidate(candidate)}
        >
          {score}
        </span>
        {candidate.screening_explanation && (
          <div className="absolute bottom-full right-0 mb-2.5 w-80 px-4 py-3 bg-gray-900/95 backdrop-blur-sm text-white text-xs leading-relaxed rounded-xl shadow-xl ring-1 ring-white/10 opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible transition-all duration-150 z-50 pointer-events-none">
            {candidate.screening_explanation}
            <div className="absolute -bottom-1.5 right-4 w-3 h-3 bg-gray-900/95 rotate-45 ring-1 ring-white/10 ring-offset-0" />
          </div>
        )}
      </div>
    );
  }

  return <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-600">Done</span>;
}
